<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.notification.editorEdit')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <b-card no-body class="mb-1">
                    <b-card-header header-bg-variant="light" header-tag="header" role="tab" class="text-capitalize">
                        <div class="card-title">
                            {{ title }} {{$t('form.notification.template')}}
                        </div>
                        <div class="float-right">
                            <b-button @click="$router.go(-1)">{{$t('button.goBack')}}</b-button>
                            <b-button variant="primary" @click="submit()">{{$t('button.save')}}</b-button>
                        </div>
                    </b-card-header>

                    <b-card-body>
                        <div class="form-group">
                            <label>{{$t('form.notification.status')}}<span class="text-danger">*</span></label>
                            <select v-model="status" class="form-control">
                                <option value="1">{{$t('form.notification.activate')}}</option>
                                <option value="0">{{$t('form.notification.deactivate')}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.subject')}}<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="subject">
                        </div>

                        <div class="form-group">
                            <label>{{$t('form.notification.message')}}<span class="text-danger">*</span></label>
                            <summernote v-model="body"></summernote>
                        </div>

                        <p class="text-muted">{{$t('form.notification.available_variables') +' '+variables}}</p>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
    import summernote from '../../components/Summernote';
    import {
        required,
        maxLength,
        minLength
    } from "vuelidate/lib/validators";
    export default {
        props: ["permissions"],
        components: {
            summernote
        },

        data() {
            return {
                alert: false,
                alertClass: null,
                alertMessage: null,

                isLoading: false,
                fullPage: true,
                closing: true,
                title:'',
                type:'',
                status: '',
                subject: '',
                body: '',
                variables: '',
                slug:this.$route.params.id,
            };
        },
        validations: {
            type: {
                required,
                maxLength: maxLength(100),
                minLength: minLength(1)
            },
            title: {
                required,
                maxLength: maxLength(100),
                minLength: minLength(1)
            },
            slug: {
                required,
                maxLength: maxLength(100),
                minLength: minLength(1)
            },
            subject: {
                required,
                maxLength: maxLength(191)
            },
            body: {
                required,
            },
            status: {
                required,
            },

        },
                computed: {
            item() {
                return this.$route.params.id;
            }
        },

        watch: {
            subject() {
                this.closing = false;
            },

            status() {
                this.closing = false;
            },

            body() {
                this.closing = false;
            }
        },

        mounted() {
            if (!this.permissions.editNotificationsEditor) {
                return this.$router.push('/');
            }

            this.getNotification();
        },

        methods: {
            /**
             * Submit templates data to server
             */
            submit() {

            this.$v.$touch();


                if (this.$v.$invalid) {
                let errorMsg = "";
                if (this.$v.type.$error) {
                    errorMsg = "Type";
                }


                if (this.$v.title.$error) {
                    errorMsg = "Type";
                }

                if (this.$v.subject.$error) {
                    errorMsg = errorMsg ? errorMsg + ", Subject" : "Subject";
                }

                if (this.$v.body.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", Body"
                        : "Body";
                }

                if (this.$v.status.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + " and Status"
                        : "Status";
                }

                if (errorMsg !== "") {
                    this.showAlert(
                        this.$t("form.validation.mandatoryFieldsError", {
                            errors: errorMsg
                        }),
                        "danger"
                    );
                    return;
                }
            }

            
                const data = { 
                                _method:'PUT',
                                title: this.title, 
                                type: this.type, 
                                slug: this.slug, 
                                subject:this.subject, 
                                body:this.body, 
                                status:this.status,
                                };

                this.isLoading = true;
                axios
                    .post("/api/notification/templates/"+data.slug, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);
                            setTimeout(() => this.$router.push({
                                name: 'NotificationEditor'
                            }), 1500)
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            /**
             * Getting Templates data from server
             */
            getNotification() {

                this.isLoading = true;

                axios
                    .get("/api/notification/templates/"+this.slug)
                    .then(response => {
                            if(response.data){
                             this.title = response.data.title;
                             this.type = response.data.type;
                             this.slug = response.data.slug;
                             this.status = response.data.status;
                             this.subject = response.data.subject;
                             this.body = response.data.body;
                             this.variables = response.data.variables;
                            
                             this.isLoading = false;
                            }
                     

                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    };

</script>
